import { useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'orthoped:demos:authed';

const RequirePassword = ({ children, title = 'Demos' }) => {
  const expectedPassword = useMemo(() => process.env.REACT_APP_DEMOS_PASSWORD || '', []);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    setAuthed(sessionStorage.getItem(STORAGE_KEY) === '1');
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!expectedPassword) {
      setError('Password protection is not configured for this deployment.');
      return;
    }

    if (password !== expectedPassword) {
      setError('Incorrect password.');
      return;
    }

    sessionStorage.setItem(STORAGE_KEY, '1');
    setAuthed(true);
  };

  const logout = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    setAuthed(false);
    setPassword('');
    setError('');
  };

  if (authed) {
    return (
      <>
        <div className="container" style={{ paddingTop: 24 }}>
          <div className="row">
            <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn--secondary" onClick={logout}>
                Logout
              </button>
            </div>
          </div>
        </div>
        {children}
      </>
    );
  }

  return (
    <section className="about static-page" style={{ paddingTop: 60 }}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-7">
            <div className="heading mb-40">
              <h2 className="heading-title">{title}</h2>
              <p className="heading-desc">Enter the password to view product demos.</p>
            </div>

            <form onSubmit={onSubmit} style={{ maxWidth: 420 }}>
              <input
                className="form-control"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button type="submit" className="btn btn--primary" style={{ marginTop: 12 }}>
                Unlock
              </button>
              {error ? (
                <p className="contact-error" style={{ marginTop: 12 }}>
                  {error}
                </p>
              ) : null}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequirePassword;
